export default function Text({text, image, classes = []}) {
    return <div style={image ? {backgroundImage: "url('" + image + "')"} : {}} className={'text ' + classes.join(' ')}>
        {text}
    </div>
}
